import { UseQueryResult } from '@tanstack/react-query'
import { useCallback } from 'react'

import { Notification, parseNotification } from '../../models/Notification'
import useQueryParameters, { queryParameters } from '../../utilities/useQueryParameters'
import * as api from '../api'
import { useApiQuery } from '../useApiQuery'
import { ReturnsNotifications } from '../useInvalidate'

const notificationFilterQueryParameters = queryParameters().number('page')

export default function useNotfications() {
  const { page, set } = useQueryParameters(notificationFilterQueryParameters)
  const setPage = useCallback((page: number) => set({ page }, { preventScrollReset: true }), [set])

  const result: UseQueryResult<{
    pageCount: number
    pageSize: number
    itemCount: number
    notifications: Notification[]
  }> = useApiQuery({
    queryKey: ['notifications', ReturnsNotifications, page],
    placeholderData: (previousData) =>
      previousData || {
        pageCount: 1,
        pageSize: 15,
        itemCount: 0,
        notifications: [],
      },
    queryFn: async () => {
      const res = await api.get(`notification?page=${page + 1}&page_size=15`)
      const groups = parseNotification.array(res.data)
      const pageCount = res.lastPage || 0
      const itemCount = res.total || 0
      return { pageCount, pageSize: 15, itemCount, notifications: groups }
    },
  })

  return {
    page,
    setPage,
    notifications: result.data?.notifications || [],
    pageCount: result.data?.pageCount || 0,
    pageSize: result.data?.pageSize || 15,
    itemCount: result.data?.itemCount || 0,
    result,
  }
}
